<template>
  <Container class="ImageBreakoutSection" tagName="aside">
    <div class="imageBreakout" >
      <div class="image" v-if="content.image">
        <SanityImage :asset="content.image.asset" />
      </div>
      <div class="textPane">
        <h2 class="heading">{{ content.heading }}</h2>
        <DefaultBlockContent v-if="content.body" :blocks="content.body" class="body" />
        <div v-if="content.cta" class="ctaWrapper">
          <CtaButton class="--dark-blue" v-bind="content.cta" />
        </div>
      </div>
    </div>
  </Container>
</template>

<script setup>
import DefaultBlockContent from '../elems/DefaultBlockContent.vue'

const { content } = defineProps({ content: Object })
</script>

<style scoped>

.ImageBreakoutSection {
  padding-top: var(--spacing-15);
  padding-bottom: var(--spacing-15);
}

.textPane {
  padding: var(--spacing-12);
  background-color: var(--bg-color-pale-gray);
  border-radius: var(--border-radius);
}

.heading {
  color: var(--text-color-black);
  font-size: var(--font-size-8);
  font-weight: 600;
  line-height: 1.2;
}

.body {
  font-size: var(--body-font-size);
  line-height: var(--body-line-height);
}

.heading + .body {
  margin-top: var(--spacing-7);
}

.body + .ctaWrapper {
  margin-top: var(--spacing-8);
}

.image + .textPane {
  margin-top: var(--spacing-10);
}

.image img {
  width: 100%;
  border-radius: var(--border-radius);
}

@media (--screen-lg) {

  .ImageBreakoutSection {
    background-color: inherit;
  }

  .imageBreakout {
    display: grid;
    grid-template-columns: 3fr 4fr;
    gap: 2rem;
    align-items: stretch;
  }

  .textPane {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .image + .textPane {
    margin-top: 0;
  }
}
</style>
